import { Component, OnInit, HostListener } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
    selector: 'app-movie-sphere-plus-page',
    templateUrl: './movie-sphere-plus-page.component.html',
    styleUrls: ['./movie-sphere-plus-page.component.scss']
})
export class MovieSpherePlusPageComponent implements OnInit {
    isMobile: boolean = false;
    bgTransform: string = 'translateY(0px)';

    constructor(private breakpointObserver: BreakpointObserver) {
        breakpointObserver.observe([
            Breakpoints.HandsetLandscape,
            Breakpoints.HandsetPortrait
        ]).subscribe(result => {
            this.isMobile = result.matches;
        });
    }

    ngOnInit(): void {}

    @HostListener('window:scroll', [])
    onScroll(): void {
        const scrollY = window.scrollY || window.pageYOffset;
        this.bgTransform = `translateY(${scrollY * 0.35}px)`;
    }
}
